import { useEffect, useState } from 'react';
import accountsAgentService from '../services/AccountsAgentService';
import { useAuth } from '../contexts/AuthContext';

// Is the signed-in user one of the accounts agent's approvers (acct_approvers — Jamie Phillips and David Ganly)?
// Decides what the portal SHOWS: Admin > Billing > Accounts Agent and QuickBooks Customers are for them only. The API enforces the
// same rule on the data itself, so hiding is presentation, not protection.
//
// Asked once per sign-in and shared: the navbar and the page guard both use it, and neither should cost a request
// per render. Any failure reads as "not an approver" — the safe answer for a visibility question.
let cached = { user: null, promise: null };

// Keyed on the signed-in user object: a new sign-in (a new object) always asks again.
const ask = (user) => {
    if (cached.user !== user || !cached.promise) {
        cached = {
            user,
            promise: accountsAgentService.me().then(r => !!(r && r.isApprover)).catch(() => false),
        };
    }
    return cached.promise;
};

export default function useAccountsApprover() {
    const { isAuthenticated, isSuperAdmin, user } = useAuth();
    const [state, setState] = useState({ loaded: false, isApprover: false });

    useEffect(() => {
        let live = true;
        // The admin menu is superadmin-only, so a non-superadmin never needs asking.
        if (!isAuthenticated || !isSuperAdmin) { setState({ loaded: true, isApprover: false }); return undefined; }
        ask(user).then(isApprover => { if (live) setState({ loaded: true, isApprover }); });
        return () => { live = false; };
    }, [isAuthenticated, isSuperAdmin, user]);

    return state;
}
